import React from "react";
import { Flex, Button, Box, Modal, Text } from "samba-ui";

import PropTypes from "prop-types";

const AreYouSureModal = ({ title, body, isOpen, onClose, onSubmit }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={{ zIndex: 10000 }}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Text fontSize={2} fontWeight={500}>
          {title}
        </Text>
      </Modal.Header>
      <Modal.Content>
        <Box>
          <Text>{body}?</Text>
        </Box>
      </Modal.Content>

      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button variant="primary" onClick={onSubmit}>
            Update
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

AreYouSureModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default AreYouSureModal;
